import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
} from "react";
import { SendType } from "./Footer";
import { MessageType } from "../../../constant/Types";

const TextInput = forwardRef(
  (
    { sendType, setSendType, sendMessage, setMsg, msg, setFocus, ...props },
    ref
  ) => {
    const buttonRef = useRef();

    function msgOnChange(event) {
      const val = event.target.value;
      if (val[0] === "\n" || val[0] === "\r") {
        return false;
      }

      if ((val === "" || val.length === 0) && sendType !== SendType.free) {
        setSendType(SendType.free);
      } else if (
        val &&
        val.length > 0 &&
        val !== "" &&
        sendType !== SendType.text
      ) {
        setSendType(SendType.text);
      }
      setMsg(val);
    }

    const submit = (e) => {
      if (e.key === "Enter" && e.ctrlKey && msg.length > 0) {
        setMsg("");
        sendMessage(MessageType.client.text, { text: msg });
      }
    };

    useImperativeHandle(ref, () => ({
      submit: () => {
        setMsg("");
        sendMessage(MessageType.client.text, { text: msg });
      },
    }));

    useEffect(() => {
      if (buttonRef.current && setFocus) {
        setFocus(buttonRef.current);
      }
    }, [buttonRef, setFocus]);

    return (
      <textarea
        placeholder={"اینجا تایپ کنید..."}
        className={"chat-input"}
        value={msg}
        onChange={msgOnChange}
        onKeyDown={submit}
        ref={buttonRef}
        {...props}
      />
    );
  }
);

export default TextInput;
